import $ from "jquery";
import wNumb from "wnumb";

const findTargetLink = $container => $container.closest(".autocomplete-container").find(".target-link");
const findTargetLinkWrapper = $targetLink => $targetLink.closest(".target-link-wrapper");
const findTargetLinkNoneSelectedWrapper = $targetLinkWrapper => $targetLinkWrapper.parent().find(".target-link-none-selected-wrapper");

$(document).on("turbolinks:load cocoon:after-insert", function() {
  // TODO: refactor this into something that applies to all admin forms that autocomplete.js for organisations
  $(".admin-form:not(.disabled) .autocomplete-target:not(.bound)").each(function () {
    const tar = $(this);
    tar.addClass("bound");
    tar.on("autocomplete.done", function () {
      const $this = $(this);
      $this.removeData(); // otherwise we get the old data values due to the jQuery cache.

      const targetId = $this.data("urlIdValue");
      let $targetLink = findTargetLink($this);

      if ($targetLink.length === 0) { return; }

      $targetLink.removeData(); // otherwise we get the old data values due to the jQuery cache.

      const $targetLinkWrapper = findTargetLinkWrapper($targetLink);
      const $targetLinkNone = findTargetLinkNoneSelectedWrapper($targetLinkWrapper);
      let newHref;

      if (targetId) {
        newHref = $targetLink.data("urlTemplate").replace("REPLACE_ID", targetId);
        $targetLinkWrapper.removeClass("hidden");

        $targetLink.attr("title", $targetLink.data("selectedTooltip"));

        $targetLinkNone.addClass("hidden");
      } else {
        newHref = $targetLink.data("urlTemplate");
        $targetLinkWrapper.addClass("hidden");

        $targetLink.attr("title", "");

        $targetLinkNone.removeClass("hidden");
      }

      $targetLink.prop("href", newHref);
    });
  });

  $(".admin-form:not(.disabled) .autocomplete-reset:not(.bound)").each(function () {
    const $target = $(this);
    $target.addClass("bound");
    const $formGroup = $target.closest(".autocomplete-container");
    const $targetLink = findTargetLink($target);
    const $targetLinkWrapper = findTargetLinkWrapper($targetLink);
    const $targetLinkNone = findTargetLinkNoneSelectedWrapper($targetLinkWrapper);

    $target.on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      $formGroup.find(".autocomplete-search-field, .autocomplete-target").val("").attr("value", "");

      if ($targetLink.length === 0) { return; }

      $targetLinkWrapper.addClass("hidden");
      $targetLinkNone.removeClass("hidden");

      $targetLink.prop("href", $targetLink.data("urlTemplate"));
    });
  });

  $(".admin-form input").keydown(function(event) {
    if(event.keyCode == 13) {
      event.preventDefault();
      return false;
    }
  });

  $(".disabled.admin-form").find("input, select, textarea").prop("disabled", true);
  $(".disabled.admin-form #application-form-object-box").find("input, select, textarea").prop("disabled", false);

  $(".disabled.admin-form").find(".add_fields, .remove_fields, .autocomplete-reset").addClass("disabled").on("click", function (e) {
    e.preventDefault();
    e.stopPropagation();
  });

  // disable mousewheel on a input number field when in focus
  // (to prevent Cromium browsers change the value when scrolling)
  $(".admin-form").on("focus", "input[type=number]", function () {
    $(this).on("mousewheel.disableScroll", function (e) {
      e.preventDefault();
    });
  });
  $(".admin-form").on("blur", "input[type=number]", function () {
    $(this).off("mousewheel.disableScroll");
  });

  $(".admin-form .checkbox .hide-no-icons").each(function () {
    const $this = $(this);

    if ($this.find("img").length > 0) {
      return;
    }

    $this.closest(".checkbox").addClass("hidden");
  });

  $(".admin-form .has-textarea-length-counter:not(.bound)").each(function () {
    const $textarea = $(this);
    const maxLength = $textarea.data("maxlength");
    if (!maxLength) { return; }

    const classes = ["textarea-length-counter"];

    $textarea.parent().append(`<div class='${classes}'>Current / Maximum allowed characters: <span class='current-length'></span> / ${maxLength}</div>`);
    const $lengthCounter = $textarea.parent().find(".textarea-length-counter");
    const $currentLength = $lengthCounter.find(".current-length");
    const getLength = () => $textarea.val().length;
    const checkLength = function () {
      const length = getLength();

      if (length > maxLength) {
        $lengthCounter.addClass("error");
        $textarea.addClass("error");
      } else {
        $lengthCounter.removeClass("error");
        $textarea.removeClass("error");
      }

      $currentLength.text(length);
    };

    $textarea.on("keyup", checkLength);
    checkLength();

    $textarea.closest("form").on("submit", function (e) {
      const length = getLength();
      if (length <= maxLength) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();

      $textarea[0].scrollIntoView();
      $textarea.focus();
    });

    $textarea.addClass("bound");
  });

  $(".admin-form p.help-block:not(.hidden)")
  .each(function () {
    const $helpBlock = $(this);
    const $formGroup = $helpBlock.closest(".form-group");
    let $label = $formGroup.find(".control-label");
    let pullRightOrNot = " pull-right";

    if ($label.length === 0) {
      // Collection sections (check_boxes/radio_buttons) render their label as a direct child div
      // of the form-group, and the Bootstrap 5 migration renamed that class from .control-label to
      // .form-label — simple_form still emits .control-label for ordinary inputs, so only the
      // collection sections landed here. Without this lookup they fell through to the fallback
      // below, which matches EVERY checkbox label in the group and gave each one its own icon
      // (40 of them on the patent tracker's Themes section). Direct child on purpose: the
      // autocomplete partial renders spacer `<label class="form-label">&nbsp;</label>` elements
      // deeper inside the group, which a descendant match would decorate too.
      $label = $formGroup.children(".form-label");
    }

    $label.css("display", "inline-block");

    if ($label.length === 0) {
      $label = $formGroup.find("label").parent();
      pullRightOrNot = "";
    }

    $label.append(`<span class="${pullRightOrNot}" style="padding-left: 5px; display: inline-block;"><i title='${$helpBlock.text()}' class='fa fa-info-circle title-tooltip'></i></span>`);

    $helpBlock.addClass("hidden");
  });

  $(".title-tooltip:not(.bound)").addClass("bound").tooltip({ container: "body" });

  $(".target-subform .transaction-organisation-country-name:not(.bound)").addClass("bound").change(function () {
    const $this = $(this);
    const countryId = $this.val();

    if (!countryId) { return; }

    const currencyCode = window && window.countryIdCurrencyIdMap && window.countryIdCurrencyIdMap[countryId];

    if (!currencyCode) { return; }

    $this.closest("form").find(".local-currency-select").each(function () {
      const $select = $(this);

      $select.val(currencyCode);
      $select.change();
    });
  });

  let removeClass;
  $(".local-currency-select.revenue").change(function () {
    const $this = $(this);
    const $form = $this.closest("form");

    // either the mouse is over it or the element has focus :D testing
    //  testing focus alone fails since if you double click quickly you can select the text and then the focus
    //    is not in the element for some reason.
    const revenueSeeNoteFieldIsFocused = $(".form-group.wd_transaction_form_revenue_local_see_note").is(":hover") ||
                                         $(document.activeElement).closest(".form-group").hasClass("wd_transaction_form_revenue_local_see_note");

    if (revenueSeeNoteFieldIsFocused) {
      // SI: when See note? for Revenue is ticked Ian does not want the Profit currency select to be blanked.
      //  So if the checkbox is focused it means it was just clicked or spaced.
      //  THIS IS A RACE CONDITION. But whatever.
      return;
    }

    const $profit = $form.find(".local-currency-select.profit");
    const $price = $form.find(".local-currency-select.price");
    const $profitWrapper = $profit.closest(".diff-inner-wrapper");

    if ($this.val() !== $price.val()) {
      window.clearTimeout(removeClass);

      $profit.val($this.val()).change();
      $profitWrapper.addClass("animate-background flash");

      removeClass = window.setTimeout(() => $profitWrapper.removeClass("flash"), 1000);
    }
  });

  const commaFormat = wNumb({
    mark: ".",
    thousand: ","
  });

  $(".separator-formatted-number-input").not(".bound").addClass("bound").each(function () {
    const $input = $(this);
    // $input.addClass("hidden");
    const $newInput = $input.after("<div />").next();
    $newInput.addClass("form-control numeric optional display-only");
    const sync = function () {
      const stringVal = $input.val();
      if (!stringVal) {
        $newInput.text(null);

        return;
      }

      if (stringVal[stringVal.length - 1] === ".") {
        return;
      }

      const value = commaFormat.from(stringVal);

      if (!value) {
        $newInput.text(null);

        return;
      }

      $newInput.text(commaFormat.to(value));
    };

    $input.keyup(sync);
    $input.change(sync);
    sync();
  });

  const privatelyHeldSelector = ".form-group.wd_transaction_form_wd_transaction_form_vendor_transaction_organisations_organisation_search";
  // Self-closing a non-void tag is invalid HTML; a browser's forgiving parser ignores the slash and
  // treats it as an unclosed opening tag instead, so the SIBLING markup that follows (the "Privately
  // held?" button, appended right after this icon in privatelyHeldTemplate below) gets swallowed
  // INSIDE this <i> rather than sitting next to it -- breaking the button's layout/hover behavior and
  // reading as "the icon isn't working" (QA, 2026-08-29). Reproduced via jsdom against both forms to
  // confirm: self-closing nests the button inside <i>; an explicit closing tag keeps them siblings.
  const privatelyHeldIcon = "<i class='fa fa-info-circle' title='Will auto-populate the text field above. Only click if the vendor is unidentified by name, but known to be in private hands.'></i>";
  const privatelyHeldTemplate = `
    <span class='privately-held-box pull-right'>${privatelyHeldIcon} <a class="btn btn-info" href='#'>Privately held?</a></span>
  `;
  $(privatelyHeldSelector).not(".privately-held-bound").addClass("privately-held-bound").each(function () {
    const $this = $(this);
    const $container = $this.closest(".autocomplete-container");
    const $resetLink = $container.find(".autocomplete-reset");

    const $button = $resetLink.after(privatelyHeldTemplate).next().find("a");

    $button.click(function (e) {
      e.preventDefault();
      e.stopPropagation();

      $container.find(".autocomplete-search-field").attr("value", "Privately held").val("Privately held").change().blur();

      setTimeout(() => $container.find("[data-autocomplete]").autocomplete("hide"), 200);
    });
  });
});

$(document).on("document:ready turbolinks:load", function() {
  $("#wd_transaction_form_price_currency_id").on("change", function () {
    const option = $(this).find("option:selected").text();
    if (option !== "USD") return;
    const money = $("#wd_transaction_form_price_local").val();
    $("#wd_transaction_form_price_usd").val(money);
  });

  $(".profit-type-input").change(function () {
    const $xInput = $(".x-profit-numeric-input-wrapper input");
    const $select = $(this);
    const selectValue = ($select.select2("data")[0] || {}).text;

    const editableXProfitNames = $select.data("editableXProfitNames");

    if (editableXProfitNames.includes(selectValue)) {
      $xInput.prop("readonly", false);
    } else {
      $xInput.prop("readonly", true);
    }
  });

  $(".also-tag-parent input").change(function () {
    const $childBox = $(this);

    if ($childBox.is(":checked")) {
      $("#" + $childBox.closest(".also-tag-parent").data().parentName).find("input").prop("checked", true);
    }
  });

  const toggleDisableFields = function () {
    const $box = $(this);
    const { targets } = $box.closest(".clear-and-disable-if-checked").data();

    const $targets = $("." + targets).not(".other-disable-checkboxes");
    const $otherBoxTargets = $("." + targets + ".other-disable-checkboxes").not($box);
    if ($box.is(":checked")) {
      $targets.prop("readonly", true);
      $targets.filter("select").prop("disabled", true);

      $targets.val("");

      $otherBoxTargets.prop("readonly", true);
      $otherBoxTargets.prop("checked", false);

      $targets.change();
    } else {
      $targets.prop("readonly", false);
      $targets.filter("select").prop("disabled", false);
      $otherBoxTargets.prop("readonly", false);

      $targets.change();
    }
  };

  $(".clear-and-disable-if-checked input").change(toggleDisableFields);
  $(".clear-and-disable-if-checked input").each(toggleDisableFields);

  $("[data-association='wd_transaction_form_target_transaction_organisation']").click(function (e) {
    const alreadyHaveATarget = $(e.target).closest("#targets").children(".nested-fields:not(.marked-for-destruction)").length > 0;

    if (alreadyHaveATarget) {
      return confirm("Are you sure you want to add a target to this deal, rather than creating a new deal?");
    } else {
      return true;
    }
  });

  // Update USD Price when changing Price local value if selected currency is USD or if changing currency
  $(document).on("change", "#wd_transaction_form_price_local, #wd_transaction_form_price_currency_id", function() {
    const $currency = $("#wd_transaction_form_price_currency_id").val();
    const $usdPriceInput = $("#wd_transaction_form_price_usd");

    if ($currency === "176") {
      const $usdPrice = $("#wd_transaction_form_price_local").val();
      $usdPriceInput.val($usdPrice);
    } else {
      $usdPriceInput.val("");
    }
  });

  $(document).on("change", ".wd_transaction_form_wd_transaction_form_vendor_transaction_organisations_share_unknown input", function () {
    const $this = $(this);
    const $shareInput = $this
                        .closest(".transaction-organisation-fields")
                        .find(".wd_transaction_form_wd_transaction_form_vendor_transaction_organisations_share_text select");
    if ($this.is(":checked")) {
      $shareInput.val("").trigger("change");
      $shareInput.prop("disabled", true);
    } else {
      $shareInput.prop("disabled", false);
    }
  });

  $(document).on("change", ".wd_transaction_form_wd_transaction_form_target_transaction_organisations_share_unknown input", function () {
    const $this = $(this);
    const $shareInput = $this
                        .closest(".transaction-organisation-fields")
                        .find(".wd_transaction_form_wd_transaction_form_target_transaction_organisations_share_text select");
    if ($this.is(":checked")) {
      $shareInput.val("").trigger("change");
      $shareInput.prop("disabled", true);
    } else {
      $shareInput.prop("disabled", false);
    }
  });

  $(document).on("change", ".wd_transaction_form_wd_transaction_form_acquiror_transaction_organisations_share_unknown input", function () {
    const $this = $(this);
    const $shareInput = $this
                        .closest(".transaction-organisation-fields")
                        .find(".wd_transaction_form_wd_transaction_form_acquiror_transaction_organisations_share_text select");
    if ($this.is(":checked")) {
      $shareInput.val("").trigger("change");
      $shareInput.prop("disabled", true);
    } else {
      $shareInput.prop("disabled", false);
    }
  });

  // Focus the Organisation input when adding a Vendor, Target or Acquirors
  const focusClosestOrganisationInput = (e, addedSubform) => {
    if ($("body.admin-wd_transaction_forms").length === 0) {
      return;
    }

    addedSubform.find("input[name*='[organisation_search]']").focus();
  };

  $(document).on("cocoon:after-insert", focusClosestOrganisationInput);
});
